import { render, staticRenderFns } from "./AnnounceList.vue?vue&type=template&id=a810b932&scoped=true&"
import script from "./AnnounceList.vue?vue&type=script&lang=js&"
export * from "./AnnounceList.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceList.vue?vue&type=style&index=0&id=a810b932&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a810b932",
  null
  
)

export default component.exports